import React from 'react';
import { Layout } from '../components/Layout';
export function HomePage() {
  return <Layout data-id="element-54">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-55">
        <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-56">
          Welcome to Forgepoint Management LLC
        </h1>
        <p className="text-lg text-gray-600" data-id="element-57">
          Your trusted partner in real estate management and investment.
        </p>
      </div>
    </Layout>;
}